/*
 * Painel de busca "slide-down" (search_type: slide_down)
 * Responsabilidade APENAS de posicionamento e acessibilidade:
 *   - posiciona o painel logo ABAIXO do header (considera barra de aviso,
 *     header sticky e responsivo) setando a variavel CSS --sd-top;
 *   - fecha com a tecla ESC.
 * O mecanismo de abrir/fechar continua sendo o do theme.js
 * (.top-search-toggle -> #search-form.open / .btn-search-close / overlay).
 */
(function () {
  function init() {
    var form = document.getElementById('search-form');
    if (!form || !form.classList.contains('search__type-slide_down')) return;

    var header =
      document.querySelector('header.header') || document.querySelector('header');
    if (!header) return;

    function place() {
      var bottom = header.getBoundingClientRect().bottom;
      if (bottom < 0) bottom = 0;
      var v = Math.round(bottom) + 'px';
      form.style.setProperty('--sd-top', v);
      // Tambem no <html> para o backdrop (.overlay_search) poder ler o mesmo valor
      // e comecar ABAIXO do header (sem escurecer o cabecalho).
      document.documentElement.style.setProperty('--sd-top', v);
    }
    place();

    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        place();
        ticking = false;
      });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    // Recalcula no momento de abrir (clique na lupa do header)
    document.querySelectorAll('.top-search-toggle').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function () {
          place();
          setTimeout(place, 60);
        },
        true
      );
    });

    // ESC fecha (aciona o botao de fechar existente)
    document.addEventListener('keydown', function (e) {
      if (
        (e.key === 'Escape' || e.key === 'Esc') &&
        document.documentElement.classList.contains('open-search')
      ) {
        var close = form.querySelector('.btn-search-close');
        if (close) close.click();
      }
    });

    // Exclusao mutua com o mega menu: se a busca esta aberta e o mouse entra
    // num item do menu principal, fecha a busca. Assim o mega menu abre limpo
    // (via :hover) sem ficar sobreposto ao painel de busca.
    document.addEventListener('mouseover', function (e) {
      if (!document.documentElement.classList.contains('open-search')) return;
      if (!e.target.closest('menu-item')) return;
      var close = form.querySelector('.btn-search-close');
      if (close) close.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
